<template>
<span class="">
  <ur-system>
    <ur-screen>
      <ur-area top="50px">
        <LayoutHeaders />
      </ur-area>
      <div class="body-wrapper">
        <div id="burger-menu">
          <span></span>
        </div>
        <ur-area id="menu" left class="sidebar-area">
          <LayoutSidebar ref="lnb" :mode="mode" />
        </ur-area>
        <ur-area right class="custom-content">
          <div class="page-custom-container">
            <Breadcrumb />
            <router-view />
          </div>
        </ur-area>
      </div>
      <ur-area>
        <LayoutFooter />
      </ur-area>
    </ur-screen>
  </ur-system>
  </span>
</template>

<script>
import LayoutHeaders from "./Header.vue";
import LayoutSidebar from "./sisSidebar.vue";
import LayoutFooter from "./Footer.vue";
import Breadcrumb from "./sisBreadcrumb.vue";

export default {

  name: "Layout",
  data() {
    return {
      showContent: false,
      mode: "desktop",
      partyName: "",
      screenSizeSm: 768,
      currentTimeDate: "",
      screenClass: false,
    };
  },
  components: {
    LayoutHeaders,
    LayoutFooter,
    LayoutSidebar,
    Breadcrumb,
  },
  mounted() {
    this.partyName = this.$store.state.partyname
      ? this.$store.state.partyname
      : localStorage.getItem("partyName");
    window.addEventListener("resize", this.resize);
    this.resize();
    setInterval(() => {
      this.getCurrentTimeDate();
    }, 1000);

    var burgerMenu = document.getElementById("burger-menu");

    burgerMenu.addEventListener("click", function () {
      this.classList.toggle("close");
      document.getElementById("menu").classList.toggle("overlay");
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    changeClass(data) {
      this.screenClass = data;
    },
    goToHome() {
      console.log('goToHome');
    },
    openDrawer(v) {
      this.$refs.lnb.openDrawer(v);
    },
    resize() {
      this.mode = window.innerWidth < this.screenSizeSm ? "mobile" : "desktop";
    },
    getCurrentTimeDate() {
      const d = new Date();
      const nth = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };
      const monthList = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      const date =
        day + nth(day) + " " + monthList[d.getMonth()] + " " + d.getFullYear();
      const time = d.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      this.currentTimeDate = `${date} at ${time}`;
    },
  },
};
</script>

<style lang="scss">
.body-wrapper {
  display: flex;
  height: calc(100vh - 74px);
  clear: both;
}
.sidebar-area {
  display: inline-block;
}
.ur-system {
  min-height: auto !important;
}
</style>

<style scoped>
#burger-menu {
  display: none;
}
@media only screen and (min-width: 280px) and (max-width: 912px) {
  #burger-menu {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0;
    left: 20px;
    top: 10px;
    overflow: visible;
    position: absolute;
    display: block;
    z-index: 999;
  }
  #burger-menu span,
  #burger-menu span:before,
  #burger-menu span:after {
    background: rgba(69, 76, 165, 1) !important;
    display: block;
    height: 2px;
    opacity: 1;
    position: absolute;
    transition: 0.3s ease-in-out;
  }
  #burger-menu span:before,
  #burger-menu span:after {
    content: "";
  }
  #burger-menu span:before {
    left: 0px;
    top: -6px;
    width: 15px;
  }
  #burger-menu span {
    right: 0px;
    top: 13px;
    width: 15px;
  }
  #burger-menu span:after {
    left: 0px;
    top: 6px;
    width: 15px;
  }
  #burger-menu.close span:before {
    top: 0px;
    transform: rotate(90deg);
    width: 15px;
  }
  #burger-menu.close span {
    transform: rotate(-45deg);
    top: 13px;
    width: 15px;
  }
  #burger-menu.close span:after {
    top: 0px;
    left: 0;
    transform: rotate(90deg);
    opacity: 0;
    width: 0;
  }
  #menu {
    z-index: 1;

    display: none;
    opacity: 0;
    text-align: center;
    transition: all 0.3s ease-in-out;
  }
  #menu.overlay {
    display: block;
    opacity: 1;
    z-index: 42;
  }
}
</style>
